import React, { useCallback } from 'react';
import Accordian from "../../Components/Accordian/Accordian";
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
var css = {
  "faq": "oalp-3PbRb",
  "accordianContainer": "oalp-2JoBM"
};
import CTA from "../../Components/CTA/CTA";
import { UNKNOWN } from "../../Constants/locations";
import { compose } from 'redux';
import UserSession from "../../Utils/UserSession";
import { withRouter } from "../../Helpers/withRouter";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
import { getThematicParams } from "../../Helpers/trackingHelper";
import withConfig from "./../../ComponentDependency/withConfig";
var defaultStyle = {};
export var FAQWidget = function FAQWidget(_ref) {
  var name = _ref.name,
    _ref$data = _ref.data,
    qnAs = _ref$data.qnAs,
    cta = _ref$data.cta,
    _ref$data$qnAsStyle = _ref$data.qnAsStyle,
    qnAsStyle = _ref$data$qnAsStyle === void 0 ? {} : _ref$data$qnAsStyle,
    metadata = _ref.metadata,
    ReactObserver = _ref.ReactObserver,
    track = _ref.track,
    browsingMode = _ref.browsingMode,
    locationId = _ref.locationId,
    origin = _ref.origin,
    params = _ref.params,
    config = _ref.config;
  var _ref2 = metadata || {},
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? defaultStyle : _ref2$style;
  var handleChange = useCallback(function (inView) {
    if (inView && track && metadata && metadata.trackingInfo && metadata.trackingInfo.impressionEvent && metadata.trackingInfo.impressionEvent.name) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin
      });
      track(metadata.trackingInfo.impressionEvent.name, Object.assign(Object.assign({}, trackingInfo), getThematicParams(params, config.get())));
    }
  }, [browsingMode, locationId, origin, track, metadata, config, params]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleChange,
    "data-aut-id": "observer"
  }), /*#__PURE__*/React.createElement("div", {
    className: css.faq,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: css.accordianContainer
  }, Array.isArray(qnAs) && qnAs.map(function (qna, idx) {
    return /*#__PURE__*/React.createElement(Accordian, {
      key: idx,
      headerText: qna.question,
      content: qna.answer,
      track: track,
      metadata: metadata,
      origin: origin,
      qnAsStyle: qnAsStyle,
      browsingMode: browsingMode
    });
  })), cta && cta.buttons && cta.buttons.map(function (btn, idx) {
    return /*#__PURE__*/React.createElement(CTA, {
      key: idx,
      widgetKey: name,
      button: btn,
      track: track,
      metadata: metadata,
      select_from: UserSession.getTabName()
    });
  })));
};
export default compose(React.memo, withRouter, withComponentDependency, withConfig)(FAQWidget);